/**
 * Product mockups. Paste the hosted image URL in each slot.
 * While a slot is empty the page draws a built-in illustration in the
 * product's palette, so nothing ever shows as a broken image.
 */
export const images = {
  /** Main pack mockup (hero) */
  hero: 'https://cdn.magicpatterns.com/uploads/4jZqYKrQspoX14JfT6MLKy/Photorealistic-product-mockup-warm-and.png',
  /** Main pack mockup (pricing card) — can reuse the hero image */
  pricing:
    'https://cdn.magicpatterns.com/uploads/4jZqYKrQspoX14JfT6MLKy/Photorealistic-product-mockup-warm-and.png',
  /** Bonus 1 to 5 mockups, in order */
  bonuses: [
    'https://cdn.magicpatterns.com/uploads/vSKBHL9WsefbZN8te4DfMZ/DPS38_-_Bono_1_-_The_Badminton_Rules__Scoring_Referee_Card.png',
    'https://cdn.magicpatterns.com/uploads/8S2VVpFVTg1rNTCr9L1pL7/DPS38_-_Bono_2_-_The_Coachs_Equipment__Court_Setup_Guide.png',
    'https://cdn.magicpatterns.com/uploads/1PFy647vY7vBpb9i3nrRkE/DPS38_-_Bono_3_-_The_Shot_Map__Terminology_Poster.png',
    'https://cdn.magicpatterns.com/uploads/88hvNpFJNuLjiGUvapDD6Q/DPS38_-_Bono_4_-_Blank_Court_Drill-Design_Sheets.png',
    'https://cdn.magicpatterns.com/uploads/7Don8s4mKTfQ43zS8Hejb2/DPS38_-_Bono_5_-_The_5-Minute_Coaching_Cues_Cheat-Sheet.png',
  ],
}
